import { genericMap2LegacyTheme } from './genericMap2LegacyTheme';
import { genericMap2Tokens } from './genericMap2Tokens';
import { propAdapter } from './propAdapter';
const map = {
  // '': '--st-dt-dimensions-z-index-100', // 100
  // '': '--st-dt-dimensions-z-index-200', // 200
  alert: '--st-dt-dimensions-z-index-300',
  // 300
  popover: '--st-dt-dimensions-z-index-400',
  // 400
  dropdown: '--st-dt-dimensions-z-index-500',
  // 500
  sideMenu: '--st-dt-dimensions-z-index-600',
  // 600
  stickyContent: '--st-legacy-dimensions-z-index-stick-content',
  // 650
  header: '--st-dt-dimensions-z-index-700',
  // 700
  flyout: '--st-dt-dimensions-z-index-800',
  // 800
  modal: '--st-dt-dimensions-z-index-900',
  // 900
  highest: '--st-dt-dimensions-z-index-1000' // 1000
};
export const map2Tokens = legacyThemeProperty => {
  return genericMap2Tokens(legacyThemeProperty, map);
};
export const map2LegacyTheme = (tokens, legacyThemeProperty) => {
  return genericMap2LegacyTheme(tokens, legacyThemeProperty, map);
};
export const zIndexPropAdapter = propAdapter(map);